import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TAppConfig, IAppConfigState } from '../types';

const initialState: IAppConfigState = {
  config: {
    appType: 'sravni.ru',
    gtmKey: '',
    originalUrl: '',
  },
};

export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setAppConfig: (state, { payload }: PayloadAction<TAppConfig>) => {
      state.config = payload;
    },
  },
});

export const { setAppConfig } = appConfigSlice.actions;
